import { advanceExpensesRoutes } from "./advance";
import { categoryHeadRoutes } from "./category-head";
import { vendorPaymentsRoutes } from "./vendor-payment";

export const expenseModuleRoutes = advanceExpensesRoutes
  .concat(vendorPaymentsRoutes)
  .concat(categoryHeadRoutes);
